module.exports = __webpack_public_path__ + "static/media/affiliate.5f74d8c6.png";